import { ManufacturingSites } from '@constants';
import { RawMaterialCombination } from '@interfaces/raw-material-combination';
import { getCall } from '@services/rest-service';

// Retrieves the raw material combination from cosmos for the specified metal combination and manufacturing site
export const getRawMaterialCombination = (baseMetal: string, cladMetal: string, manufacturingSite: ManufacturingSites): Promise<RawMaterialCombination> => {
    return getCall<RawMaterialCombination>(`raw-material-combinations?baseMetal=${baseMetal}&cladMetal=${cladMetal}&manufacturingSite=${manufacturingSite}`);
};
